import styled from 'styled-components'

const Container = styled.div<{ active: boolean }>`
  transition: all linear 0.2s;
  transform: rotate(${({ active }) => (active ? '180deg' : '0deg')});
`

const Rotate = ({ active = false, children }: { active: boolean; children: any }) => {
  return <Container active={active}>{children}</Container>
}

export default Rotate
